import { FlexColumn } from "../../../../../../Common/__styles__/Layout";
import { useSubmissionsBuilderContext } from "../../SubmissionsBuilderContext";
import { FieldsList } from "./FieldsList";
import { ModulesList } from "./ModulesList";

export function FieldsTab() {
  const { existingSubmissionType } = useSubmissionsBuilderContext();

  return (
    <FlexColumn gap="l">
      <FieldsList atFieldPath={[]} />
      {!existingSubmissionType && <ModulesList />}
    </FlexColumn>
  );
}
